<template>
   <!-- When a component needs to make a request to fetch data, wrap this component around it to fade in the component after the request has completed  -->
   <div class="relative w-full">
      <transition name="portal-fade" mode="out-in">
         <!-- Loading -->
         <LoadingSpinner v-if="isLoading" size="md" />

         <!-- Error section -->
         <div v-else-if="hasLoadErrors" class="container flex w-full flex-col items-center justify-center text-center">
            <!-- Heading - note we use P here and not a heading because we dont know what the parent headings might be -->
            <p class="text-bolder mt-4 text-xl md:text-2xl">{{ $t("system.errors.error_failed_fetch") }}</p>

            <!-- Subheading -->
            <!-- <p v-if="loadErrorMessage" class="text-regular mt-2 text-lg md:text-xl" data-cy="request-loader-error">
               Failed to process data for: {{ loadErrorMessage }}.
            </p> -->

            <!-- User actions -->
            <div class="mt-8 flex grow flex-wrap items-center justify-center gap-3">
               <!-- retry request -->
               <DefaultButton :text="$t('system.retry')" size="sm" @click="$emit('retry')" />

               <!-- let us know (intercom or email) -->
               <SupportButton v-if="hasContactButton" size="sm" :text="$t('system.contact_us')" />
            </div>
         </div>

         <!-- Component slot -->
         <div v-else>
            <slot />
         </div>
      </transition>
   </div>
</template>

<script setup lang="ts">
import { useI18n } from "@/vue-i18n/vue-i18n";

defineEmits(["retry"]);

const { t: $t } = useI18n();

interface Props {
   isLoading: boolean;
   loadErrors?: Error[];
   hasContactButton?: boolean;
   // loadErrorMessage?: string; // error message to display to the user
}
const props = withDefaults(defineProps<Props>(), {
   isLoading: true,
   hasContactButton: false,
   // loadErrorMessage: null,
});

const hasLoadErrors = computed(() => {
   const hasErrors = props.loadErrors?.length > 0;
   if (hasErrors) {
      // log to sentry
      console.error("Page loading error: ", props.loadErrors);
   }

   return hasErrors;
});
</script>

<style scoped lang="scss"></style>
